import './Section.css';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  background?: 'light' | 'beige' | 'dark';
  id?: string;
}

const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  background = 'light',
  id,
}) => {
  return (
    <section
      id={id}
      className={`section section--${background} ${className}`}
    >
      {children}
    </section>
  );
};

export default Section;
